import React from 'react';
import classNames from 'classnames';

import { Avatar } from 'modules/ui';

import classes from './MessageHeading.module.scss';

function MessageHeading({
  title,
  titleClassName,
  subtitle,
  subtitleClassName,
  photoUrl,
  displayAvatar = true,
}) {
  return (
    <div className={classes.heading}>
      {displayAvatar && <Avatar size={32} photoUrl={photoUrl} />}
      <div className={classes.headingText}>
        <span className={classNames(classes.headingTitle, titleClassName)}>
          {title}
        </span>
        <p className={classNames(classes.headingSubtitle, subtitleClassName)}>
          {subtitle}
        </p>
      </div>
    </div>
  );
}

export default MessageHeading;
